// extracted by mini-css-extract-plugin
export var contentBody = "_ar-9";
export var headerImage = "_ar-2";
export var imageButton = "_ar-7";
export var imageButtonIcon = "_ar-8";
export var imageHeader = "_ar-4";
export var imageHeaderText = "_ar-5";
export var imageOverlay = "_ar-3";
export var imageTitle = "_ar-6";
export var imageWrapper = "_ar-1";
export var taskList = "_ar-a";
export var widget = "_ar-0";